
import { useParams } from "react-router-dom";
import { colors, generateSchedule, masterSchedule } from "../../js/generateSchedule";
import { getCurrentClass, getCurrentDay, setFakeTimers } from "../../js/getLiveClass";
import CurrentClass from "../partials/CurrentClass";
import {useState, useEffect} from "react"
import AssignmentEntry from "../partials/AssignmentEntry";
import { getLunch, getMX } from "../../js/getLunch";
function Embed() {
  const {type} = useParams();
  const [lunch, setLunch] = useState([]);
  const [mx, setMX] = useState([]);
  const [beforeMx, setBeforeMx] = useState(false);
    const [currentClass, setCurrentClass] = useState(0);
    const [nextClass, setNextClass] = useState(0);
    const default_classes = {settings:{wschedule:true, local:true}, classes:{}}

    useEffect(() => {
      if (type === "lunch") {
  //      var clock = setFakeTimers(new Date("9/18/24 10:00 AM"));
        // generateSchedule(default_classes, {}).then((schedule)=> {
        // var day = masterSchedule[getCurrentDay(new Date(), true)];
        // var mxes = day.map((a) => a[1] === "MX")
        // if (mxes.some((a) => a) && mxes.findIndex((a) => a) >= day.findIndex(a => a[1] === getCurrentClass(schedule)[0][1])) {
        // getMX().then(mx => {
        //   if (Object.values(mx)[new Date().getDay()-1] === undefined) {
        //     setCurrentClass(["No MX Today"])
        //   } else {
        //   console.log(Object.values(mx))
        //   setCurrentClass(Object.values(mx)[new Date().getDay()-1])
        //   }
        //   setLunch(1)
        // })
        // } else {
    //      var clock = setFakeTimers(new Date("9/5/24 11:39:30 AM"));
        getLunch().then(lunch => {
          if (Object.values(lunch)[new Date().getDay()-1] === undefined) {
            setLunch(["No Lunch Today"])
          } else {
            var lunch = Object.values(lunch)[new Date().getDay()-1]
            var lunchLines = []
            lunch.forEach((a) => {
              if (a.startsWith("•")) {
                lunchLines.push(a)
              } else {
                lunchLines[lunchLines.length-1] += " " + a
              }})
            setLunch(lunchLines)
          }
        })
        getMX().then(mx => {
          var dateString = new Date().toDateString().split(" ").slice(0, 3).join(" ")
          console.log(mx, dateString)
          if (mx[dateString] === undefined) {
            setMX(["No MX Today"])
            
          } else {
            console.log("No MX Today", dateString)
          setMX(mx[dateString])
          }
        })

        setInterval(() => {
          
        generateSchedule(default_classes, {}).then((schedule)=> {
        var day = masterSchedule[getCurrentDay(new Date(), true)];
        var mxes = day.map((a) => a[1] === "MX")
    //    console.log(mxes, mxes.findIndex((a) => a), day.findIndex(a => a[1] === getCurrentClass(schedule)[0].name), getCurrentClass(schedule)[0])
        if (mxes.some((a) => a) && mxes.findIndex((a) => a) >= day.findIndex(a => a[1] === getCurrentClass(schedule)[0].name)) {
        setBeforeMx(false)
        } else {
          setBeforeMx(false)
        }
      })
      }, 5000)
    
    //})
      } else {
    generateSchedule(default_classes, {}).then((schedule)=> {
  //    var clock = setFakeTimers();
      setInterval(() => {
        var c = getCurrentClass(schedule)
        setCurrentClass(c[0])
        setNextClass(c[1])
      }, 1000)
    })
  }
}, [])


if (currentClass === 0 && lunch === 0) return <div></div>
  if (type === "lunch") {
    return (<div>
      <div class="row  justify-content-center text-center">
        <div className="col-3-sm ">
          <div class="card  mx-auto " style={{width: "20rem", backgroundColor:colors.MAIN, height:210}}>
                        <div class="card-body mt-2 pt-0">
                        <h5 class="card-title text-center">{beforeMx ? "MX" : "Lunch"}</h5>
                        
                          {beforeMx ? mx.map((a) => (
                            <p class="card-text pb-0 mb-0">{a}</p>
                          )) :
                          lunch.map((a) => (
                            <p style={{fontSize:Math.min(190/lunch.reduce((tot, val) => tot += val.length, 0), 0.95)+"rem"}}class="card-text pb-0 mb-0">{a}</p>
                          ))}
                    

                    </div>
          </div>
        </div>
        </div>
    </div>) 
    } else {
    return (<div>

<div class="row pt-2 justify-content-center text-center">
  <div className="col-3-sm ">
    <h4>It's Day {getCurrentDay(new Date(), true)+1}</h4>
    <h4>Happening Now</h4>
    <CurrentClass block={currentClass} classTime={true} />

      </div>
      </div>



<div class="pt-4 pb-4 row justify-content-center text-center">
<div className="col-3-sm ">
    <h4>Up Next</h4>
    <CurrentClass block={nextClass} classTime={false} />

       
</div>
  </div>
  <div class=" row justify-content-center text-center">
<div className="col-3-sm ">
    <div class="container">
        <div class="row">
            <div class="col-2">
    <img src="/logo192.png" width="48px"/>
    </div>
    <div class="col-10">
    <h5>Powered By Skilldule</h5>
    <p class="text-secondary" style={{fontSize:"10px"}}>View your own schedule at <a href="#">https://witskilldule.web.app</a></p> 
    </div>
    </div>
    </div>

       
</div>
  </div>
    </div>)
}
}

export default Embed;